















import swiper, { Pagination, Autoplay, SwiperOptions } from 'swiper';
import { directive } from 'vue-awesome-swiper';
import { Component, Prop, Vue } from 'vue-property-decorator';
import 'swiper/swiper-bundle.css';

swiper.use([Pagination, Autoplay]);

@Component({
  directives: {
    swiper: directive,
  },
})
export default class CampaignSwiper extends Vue {
  @Prop() private slides!: Array<{
    img: string;
    alt: string;
    link: string;
  }>;

  swiperOption: SwiperOptions = {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 15,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  };
}
